import { useState } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { QRCodeSVG } from "qrcode.react";
import { toast } from "sonner";
import { api, errMsg, fmt } from "../lib/api";

function labelHtml(b, area, stock) {
  const qr = renderToStaticMarkup(<QRCodeSVG value={`${window.location.origin}/scan/${b.barcode_id}`} size={300} level="M" />);
  return `<div class="label">
    <div class="hd"><img src="${window.location.origin}/honglu-logo.png"/><div><b>PT HONGLU BAJA INDONESIA</b><small>WAREHOUSE BARCODE SYSTEM / 仓库条码</small></div></div>
    <div class="qr">${qr}</div>
    <div class="bid">${b.barcode_id}</div>
    <div class="code">${b.material_code}</div>
    <table>
      <tr><td>Kategori / 类别</td><td>${b.kategori}</td></tr>
      <tr><td>Spesifikasi / 规格</td><td>${b.spesifikasi}</td></tr>
      <tr><td>Dimensi × Panjang</td><td>${b.dimensi} × ${b.panjang}</td></tr>
      <tr><td>Grade / 钢级</td><td>${b.grade || ""}${b.tebal ? " • T " + b.tebal + "mm" : ""}</td></tr>
      <tr><td>Area / 区域</td><td><b>${area}</b> • Stok ${fmt(stock)} ${b.satuan}</td></tr>
      <tr><td>Registrasi / 登记</td><td>${String(b.reg_date).slice(0, 10)} • ${b.supplier || "-"}</td></tr>
    </table></div>`;
}

const CSS = `@page{size:100mm 150mm;margin:0}*{box-sizing:border-box}body{margin:0;font-family:Arial,"Microsoft YaHei",sans-serif}
.label{width:100mm;height:150mm;padding:5mm;page-break-after:always;display:flex;flex-direction:column;border:0}
.hd{display:flex;gap:3mm;align-items:center;border-bottom:.4mm solid #000;padding-bottom:2mm}.hd img{width:12mm;height:12mm}
.hd b{display:block;font-size:11pt}.hd small{font-size:7pt}.qr{display:flex;justify-content:center;margin:3mm 0}.qr svg{width:62mm;height:62mm}
.bid{text-align:center;font-size:17pt;font-weight:900;letter-spacing:.5px}.code{text-align:center;font-size:10pt;font-weight:700;margin-bottom:2mm}
table{width:100%;border-collapse:collapse;font-size:8pt}td{border:.2mm solid #000;padding:1mm 1.5mm}td:first-child{width:36%;color:#333}`;

export function openPrint(b, area, stock, count) {
  const w = window.open("", "_blank", "width=480,height=720");
  if (!w) { toast.error("Pop-up diblokir browser / 弹窗被拦截"); return; }
  w.document.write(`<html><head><title>Label Barcode</title><style>${CSS}</style></head><body>${Array.from({ length: count }, () => labelHtml(b, area, stock)).join("")}<script>window.onload=()=>setTimeout(()=>window.print(),300)<\/script></body></html>`);
  w.document.close();
}

export default function PrintDialog({ barcodeId, area, stock, satuan, onClose }) {
  const [mode, setMode] = useState("AUTO");
  const [n, setN] = useState(Math.max(1, Math.round(stock || 1)));
  const [busy, setBusy] = useState(false);
  const count = mode === "AUTO" ? Math.max(1, Math.round(stock || 1)) : Number(n);
  const go = async () => {
    if (busy) return;
    if (!(count >= 1 && count <= 500)) { toast.error("Jumlah label 1-500 / 标签数量1-500"); return; }
    setBusy(true);
    try {
      const r = await api.post("/print", { barcode_id: barcodeId, area, mode, qty_label: count });
      openPrint(r.data.barcode, area, stock, count);
      toast.success(`Print job ${r.data.job.job_id} • stok tidak berubah / 库存未变`);
      onClose();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="modal-overlay" data-testid="print-dialog">
      <div className="modal-box small">
        <h3>Cetak Label / 打印标签</h3>
        <p className="muted">{barcodeId} • Area {area} • Stok {fmt(stock)} {satuan} • Ukuran 100 × 150 mm (EPOS EP40D — belum diverifikasi pada printer fisik)</p>
        <div className="seg">
          <button className={mode === "AUTO" ? "on" : ""} onClick={() => setMode("AUTO")} data-testid="print-mode-auto">AUTO SESUAI QTY / 自动数量</button>
          <button className={mode === "MANUAL" ? "on" : ""} onClick={() => setMode("MANUAL")} data-testid="print-mode-manual">MANUAL / 手动</button>
        </div>
        {mode === "MANUAL" && (<><label>Jumlah Label / 标签数量</label><input type="number" min="1" max="500" value={n} onChange={(e) => setN(e.target.value)} data-testid="print-qty-input" /></>)}
        <div className="muted">Total label: <b data-testid="print-total-labels">{count}</b></div>
        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onClose} data-testid="print-cancel-btn">Batal / 取消</button>
          <button className="btn btn-success" onClick={go} disabled={busy} data-testid="print-confirm-btn">CETAK / 打印</button>
        </div>
      </div>
    </div>
  );
}
